// 좌측 카테고리 트리(최대 3단계): 펼치기/접기, 들여쓰기, 선택 강조, 높이제한+스크롤
import { useState } from 'preact/hooks';
import type { Category } from '@shared/types';
import { buildCategoryTree, type CategoryNode } from '../core/categoryTree';

interface Props {
  categories: Category[];
  selectedId: number | null;
  open: boolean;
  onSelect: (id: number) => void;
}

export function CategorySidebar({ categories, selectedId, open, onSelect }: Props) {
  const tree = buildCategoryTree(categories);
  const [collapsed, setCollapsed] = useState<Set<number>>(new Set());

  const toggle = (id: number) =>
    setCollapsed((prev) => {
      const next = new Set(prev);
      next.has(id) ? next.delete(id) : next.add(id);
      return next;
    });

  const renderNodes = (nodes: CategoryNode[]) => (
    <ul class="tree">
      {nodes.map((node) => {
        const hasChildren = node.children.length > 0;
        const isOpen = !collapsed.has(node.id);
        return (
          <li key={node.id}>
            <div
              class={`tree-row ${node.id === selectedId ? 'active' : ''}`}
              style={`padding-left:${(node.depth - 1) * 16 + 8}px`}
              onClick={() => onSelect(node.id)}
            >
              {hasChildren ? (
                <button
                  class="tree-row__chev"
                  onClick={(e) => {
                    e.stopPropagation();
                    toggle(node.id);
                  }}
                  aria-label={isOpen ? '접기' : '펼치기'}
                >
                  {isOpen ? '▾' : '▸'}
                </button>
              ) : (
                <span class="tree-row__dot" />
              )}
              <span class="tree-row__name">{node.name}</span>
            </div>
            {hasChildren && isOpen && renderNodes(node.children)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <nav class={`sidebar ${open ? 'open' : ''}`}>
      <div class="sidebar__head">카테고리</div>
      <div class="sidebar__scroll">
        {tree.length === 0 ? (
          <div class="empty" style="padding:12px">카테고리가 없습니다.</div>
        ) : (
          renderNodes(tree)
        )}
      </div>
    </nav>
  );
}
